import { lazy } from "react";
import { transmissionValidatorSVG } from '../shared/helpers/icons';

const EntryPoint = lazy(() => import(/* webpackChunkName: "transmission" */ './components/EntryPoint'));
const TransmissionLoader = lazy(() => import(/* webpackChunkName: "transmissionLoader" */ './components/TransmissionLoader'));

export const defaultPath = '/transmissionValidator';

export const innerRoutes = [
    {
        path: `${defaultPath}/:imei`,
        Component: TransmissionLoader,
        exact: true,
        icon: transmissionValidatorSVG,
        title: {
            key: '',
            plural: false
        },
        subTitle: {
            key: '',
            plural: false
        }
    },
    {
        path: `${defaultPath}/`,
        Component: TransmissionLoader,
        exact: true,
        icon: transmissionValidatorSVG,
        title: {
            key: '',
            plural: false
        },
        subTitle: {
            key: '',
            plural: false
        }
    }
];

const Stock = {
    path: defaultPath,
    Component: EntryPoint,
    exact: false,
    icon: transmissionValidatorSVG,
    title: {
        key: 'transmission_validator',
        plural: false
    },
    subTitle: {
        key: 'check_if_devices_gps',
        plural: false
    },
    innerRoutes: innerRoutes,
    pathChilds: innerRoutes.map(e => e.path)
};

export default Stock;
